import React, {useEffect, useState} from 'react';
import {Box, Divider, Tab, Tabs} from "@material-ui/core";
import messages from "res/messages/farsi";
import TabPanel from "components/tab/TabPanel";
import KeyValueTable from "components/table/KeyValueTable";
import {Animated} from "react-animated-css";
import AddComment from "./AddComment";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import {useHistory} from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import ICShoppingCartIcon from "@material-ui/icons/ChatBubbleOutline";


export default function Score(props) {

    const [scoreValue, setScoreValue] = useState(undefined)
    const [scoreDecimal, setScoreDecimal] = useState(undefined)
    const [empthyStarNumber, setEmpthyStarNumber] = useState(undefined)
    const history = useHistory()

    useEffect(() => {
        manageScoreStars()
    }, [props.score])


    function manageScoreStars() {

        if (props.count !== undefined && props.score !== undefined) {

            let score = parseInt(props.score);
            let count = parseInt(props.count);

            if (count > 0 && score <= 5 && score > 0) {

                let value_score = props.score.toString();
                let arrayScore = value_score.split('.');
                let emptyStar = 5 - arrayScore[0];


                const scoreNumberArray = Array.from({length: arrayScore[0]}, (_, index) => index + 1);
                setScoreValue(scoreNumberArray)

                if (arrayScore[1] && arrayScore[1] > 0) {
                    const scoreDecimalArray = Array.from({length: 1}, (_, index) => index + 1);
                    setScoreDecimal(scoreDecimalArray)
                    emptyStar = emptyStar - 1;
                } else {
                    setScoreDecimal(undefined)
                }

                const empthyStarNumberArray = Array.from({length: emptyStar}, (_, index) => index + 1);
                setEmpthyStarNumber(empthyStarNumberArray)

            } else {
                const empthyStarNumberArray = Array.from({length: 5}, (_, index) => index + 1);
                setEmpthyStarNumber(empthyStarNumberArray)
            }

        }


    }

    function view() {
        let rows = [];

        rows.push({
            name: messages.score,
            value: <div>
                {props.score && props.score > 0 ?
                    <div>
                        {scoreValue && scoreValue.length > 0 && scoreValue.map((i) => (
                            <StarIcon key={i} style={{fill: '#f9a825'}}/>

                        ))}
                        {scoreDecimal && scoreDecimal.length > 0 && scoreDecimal.map((j) => (
                            <StarHalfIcon key={j} style={{fill: '#f9a825', transform: 'scale(-1,1)'}}/>

                        ))}

                        {empthyStarNumber && empthyStarNumber.length > 0 && empthyStarNumber.map((k) => (
                            <StarBorderIcon key={k} style={{fill: '#f9a825'}}/>
                        ))}
                    </div> : <div>
                        {[1, 2, 3, 4, 5].map((k) => (
                            <StarBorderIcon key={k} style={{fill: 'rgb(247 222 182)'}}/>
                        ))}
                    </div>
                }
                <div>
                    {props.count && props.count > 0 ? (props.score && props.score > 0 ?
                        <p> امتیاز {props.score} از {props.count} دیدگاه </p> :
                        <p> 0 از {props.count} دیدگاه </p>) : <p> نظری ثبت نشده است </p>
                    }

                </div>
            </div>,
        })


        if (props.suggest && props.suggest > 0) {
            rows.push(
                {
                    name: messages.suggest,
                    value: <div>
                        پیشنهاد شده توسط {props.suggest} مشتری
                    </div>,

                }
            )

        }

        if (authenticationViewModel.isLogin) {
            rows.push({
                name: <div>{messages.LeaveACommentAboutThisProduct}</div>,
                value: <div style={{float: 'left'}}>
                    <Animated
                        animationIn="slideInDown"
                        animationInDuration={500}
                    >
                        <AddComment {...props}  />
                    </Animated>
                </div>,

            })
        } else {
            rows.push({
                name: <div>{messages.beforSetCommentPleaseLigin} </div>,
                value: <div style={{float: 'left'}}>
                    <Animated
                        animationIn="slideInDown"
                        animationInDuration={500}>
                        <div>
                            <IconTitleButtonRound
                                backgroundcolor={"var(--red_3)"}
                                height={"3em"}
                                width={"100%"}
                                direction="ltr"
                                fontSize="mediumTextBold"
                                onClick={() => {
                                        props.onShowLogin({
                                            showLogin: true,
                                            goToLogin: () => {
                                                props.onNavigate(history, "/login")
                                            }
                                        })

                                }}
                                icon={<ICShoppingCartIcon
                                    className={'whiteColor'}
                                    fontSize={"small"}/>}
                                title={messages.submitComment}/>
                        </div>
                    </Animated>
                </div>,

            })
        }


        return <div className="" style={{minHeight: "15em"}}>
            <Box>
                <Box style={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={0} aria-label="basic tabs example">
                        <Tab label={messages.customersScore}/>
                    </Tabs>
                    <Divider/>
                </Box>
                <TabPanel style={{padding: "1em"}} value={0} index={0}>
                    <KeyValueTable rows={rows}/>
                </TabPanel>
            </Box>
        </div>

    }

    return (<>
        {view()}
    </>)
}